import { IEmailProvider, EmailData, EmailResponse } from '../types';
import emailjs from '@emailjs/browser';

/**
 * EmailJS Provider - Sin backend, todo en frontend
 * Setup: 1-2 minutos
 * Costo: Gratis hasta 200 emails/mes
 * 
 * Pasos:
 * 1. Crear cuenta en https://www.emailjs.com/
 * 2. Agregar servicio de email (Gmail, Outlook, etc.)
 * 3. Crear template de email
 * 4. Obtener: Service ID, Template ID, Public Key
 * 5. Configurar variables de entorno con tus credenciales
 */
export class EmailJSProvider implements IEmailProvider {
  name = 'EmailJS';

  private getConfig() {
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!serviceId || !templateId || !publicKey) {
      throw new Error('EmailJS: Configuración incompleta. Verifica REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID, REACT_APP_EMAILJS_PUBLIC_KEY');
    }

    return { serviceId, templateId, publicKey };
  }

  async sendEmail(data: EmailData): Promise<EmailResponse> {
    try {
      const templateParams = {
        from_name: data.name,
        from_email: data.email,
        to_name: 'Alexander Quito',
        message: data.message,
      };

      // Incluir token de reCAPTCHA si está disponible
      if (data.recaptchaToken) {
        // EmailJS puede usar el token para validación adicional
        (templateParams as any)['g-recaptcha-response'] = data.recaptchaToken;
      }

      const { serviceId, templateId, publicKey } = this.getConfig();

      const response = await emailjs.send(
        serviceId,
        templateId,
        templateParams,
        publicKey
      );

      if (response.status === 200) {
        return {
          success: true,
          message: 'Email enviado correctamente'
        };
      }

      throw new Error(`EmailJS error: ${response.text}`);

    } catch (error: any) {
      console.error('EmailJS Error:', error);
      return {
        success: false,
        message: error.message || 'Error al enviar el email'
      };
    }
  }
}
